import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";

export default function ProtectedRoute({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505]">
      <div className="text-xs uppercase tracking-[0.3em] text-zinc-500">Caricamento...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  const userRoles = user.roles || (user.role ? [user.role] : []);
  if (roles && !roles.some((r) => userRoles.includes(r))) return <Navigate to="/" replace />;
  return children;
}
